import UnitSearchList from "components/common/dl_unit/UnitSearchList/UnitSearchList";

export default function Hemeroteka() {
  return (
    <div>
      <UnitSearchList isHM2={true} />
    </div>
  );
}
